import axios from "@/lib/axios";

export type DownloadAuditResultRequestParam = {
  companyId: string;
  auditId: string;
};

export type DownloadAuditResultResponse = Blob;

export const downloadAuditResult = (params: DownloadAuditResultRequestParam) =>
  axios.get<DownloadAuditResultResponse>(
    `/v1/companies/${params.companyId}/audits/${params.auditId}/download-result`,
    {
      responseType: "blob",
    },
  );
